import { API_VERSION } from 'src/constants/api-routes';

// The active API version is stored by `accountLoader`; requests fall back to v1 until it runs.
export const getApiVersion = (): string => localStorage.getItem('API_VERSION') || API_VERSION.V1;
